import $ajax from '@/api/request'
import Cookies from 'js-cookie'

const UrlMap = {
  GET_USER_INFO: '//api.bilibili.com/x/web-interface/nav',
  LOGIN_OUT: '//passport.bilibili.com/login/exit/v2',
  GET_ROOM_INFO: '//api.live.bilibili.com/xlive/open-platform/v1/audit/GetRoomInfo',
}

/**
 * 获取用户信息
 * 应避免在page页静默加载使用id
 */
export const getUserInfo = async () => {
  return await $ajax.get(UrlMap.GET_USER_INFO)
}

export const handleLoginOut = async () => {
  return await $ajax.post(UrlMap.LOGIN_OUT, { biliCSRF: Cookies.get('bili_jct') })
}

export const getRoomInfo = async () => {
  return await $ajax.get(UrlMap.GET_ROOM_INFO)
}
